import { z } from "zod";
// --- Client -> Server Messages ---
export const ConnectMessageSchema = z.object({
    type: z.literal("CONNECT"),
});
export const JoinEventMessageSchema = z.object({
    type: z.literal("JOIN_EVENT"),
    payload: z.object({
        eventId: z.string(),
    }),
});
export const LeaveEventMessageSchema = z.object({
    type: z.literal("LEAVE_EVENT"),
});
export const PingMessageSchema = z.object({
    type: z.literal("PING"),
});
export const HeartbeatMessageSchema = z.object({
    type: z.literal("HEARTBEAT"),
});
export const ClientMessageSchema = z.discriminatedUnion("type", [
    ConnectMessageSchema,
    JoinEventMessageSchema,
    LeaveEventMessageSchema,
    PingMessageSchema,
    HeartbeatMessageSchema,
]);
// --- Server -> Client Messages ---
export const ConnectedMessageSchema = z.object({
    type: z.literal("CONNECTED"),
});
export const RoomJoinedMessageSchema = z.object({
    type: z.literal("ROOM_JOINED"),
    payload: z.object({
        eventId: z.string(),
    }),
});
export const RoomLeftMessageSchema = z.object({
    type: z.literal("ROOM_LEFT"),
});
export const DisconnectedMessageSchema = z.object({
    type: z.literal("DISCONNECTED"),
    payload: z.object({
        reason: z.string(),
    }),
});
export const PresenceUpdateMessageSchema = z.object({
    type: z.literal("PRESENCE_UPDATE"),
    payload: z.object({
        count: z.number(),
        timestamp: z.number(),
    }),
});
export const PongMessageSchema = z.object({
    type: z.literal("PONG"),
});
export const ErrorMessageSchema = z.object({
    type: z.literal("ERROR"),
    payload: z.object({
        code: z.string(),
        message: z.string(),
    }),
});
// --- Broadcast Messages ---
import { BroadcastColorSchema, BroadcastEmojiSchema, BroadcastCountdownSchema, BroadcastColorModeSchema, BroadcastBlinkIntervalSchema, BroadcastHoldDurationSchema } from "../schemas/broadcast";
export const ColorChangedMessageSchema = z.object({
    type: z.literal("COLOR_CHANGED"),
    payload: z.object({
        color: BroadcastColorSchema,
        timestamp: z.number(),
        mode: BroadcastColorModeSchema,
        blinkIntervalMs: BroadcastBlinkIntervalSchema,
        holdDuration: BroadcastHoldDurationSchema,
    }),
});
export const EmojiTriggeredMessageSchema = z.object({
    type: z.literal("EMOJI_TRIGGERED"),
    payload: z.object({
        emoji: BroadcastEmojiSchema,
        timestamp: z.number(),
    }),
});
export const CountdownStartedMessageSchema = z.object({
    type: z.literal("COUNTDOWN_STARTED"),
    payload: z.object({
        seconds: BroadcastCountdownSchema,
        timestamp: z.number(),
    }),
});
export const EventPausedMessageSchema = z.object({
    type: z.literal("EVENT_PAUSED"),
});
export const EventResumedMessageSchema = z.object({
    type: z.literal("EVENT_RESUMED"),
});
export const EventEndedMessageSchema = z.object({
    type: z.literal("EVENT_ENDED"),
});
export const ServerMessageSchema = z.discriminatedUnion("type", [
    ConnectedMessageSchema,
    RoomJoinedMessageSchema,
    RoomLeftMessageSchema,
    DisconnectedMessageSchema,
    PongMessageSchema,
    ErrorMessageSchema,
    ColorChangedMessageSchema,
    EmojiTriggeredMessageSchema,
    CountdownStartedMessageSchema,
    EventPausedMessageSchema,
    EventResumedMessageSchema,
    EventEndedMessageSchema,
    PresenceUpdateMessageSchema,
]);
